import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import ThemeSelector from './ThemeSelector';
import './Navbar.css';

const Navbar = ({ userInfo, onSignOut }) => {
    const [enabled, setEnabled] = useState(() => {
        try {
            return localStorage.getItem('navConsent') === 'true';
        } catch (e) {
            return false;
        }
    });

    useEffect(() => {
        const handler = () => {
            try {
                setEnabled(localStorage.getItem('navConsent') === 'true');
            } catch (e) {
                setEnabled(false);
            }
        };
        window.addEventListener('navConsentChanged', handler);
        return () => window.removeEventListener('navConsentChanged', handler);
    }, []);

    return (
        <nav className="navbar">
            <h1><Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>DICOMVii</Link></h1>
            <div className="links">
                {enabled ? (
                    <>
                        <Link to="/">Home</Link>
                        <Link to="/dicom-web">DICOM Web</Link>
                        <Link to="/dicom">Manual Viewer</Link>
                    </>
                ) : (
                    <span className="nav-disabled-note">Navigation disabled until consent</span>
                )}
            </div>
            <div className="navbar-right">
                <ThemeSelector />
                {userInfo && (
                    <div className="user-menu">
                        <span className="username">{userInfo.preferred_username}</span>
                        <button className="logout-btn" onClick={onSignOut}>Logout</button>
                    </div>
                )}
            </div>
        </nav>
    )
}

export default Navbar;
